import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFavicon = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_132_10897)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 32,
				rx: 9.33333,
				fill: "#610CFF"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 32,
				rx: 9.33333,
				fill: "url(#paint0_radial_132_10897)",
				fillOpacity: .15
			}),
			/* @__PURE__ */ _jsxs("g", {
				filter: "url(#filter0_dddd_132_10897)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M12.2322 16.705L12.3451 17.5977C12.3654 17.7584 12.5843 17.7906 12.65 17.6425L13.0662 16.705C14.0286 14.5323 16.0062 12.8333 18.2858 12.2168L19.2713 11.9509C19.4271 11.9088 19.4297 11.6887 19.2749 11.643L18.4179 11.3899C16.3346 10.7734 14.8967 9.07435 14.6249 6.90168L14.512 6.00901C14.4917 5.84828 14.2728 5.81609 14.2071 5.96416L13.7909 6.90168C12.8285 9.07435 10.8509 10.7734 8.57133 11.3899L7.5858 11.6558C7.42997 11.6979 7.42737 11.918 7.58217 11.9637L8.43924 12.2168C10.5225 12.8333 11.9604 14.5323 12.2322 16.705Z",
						fill: "url(#paint1_linear_132_10897)"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M24.2261 16.8968C22.992 16.5322 22.1428 15.5286 21.9805 14.243L21.8978 13.5878C21.8775 13.427 21.6585 13.3948 21.5928 13.543L21.2823 14.243C20.7125 15.5286 19.5425 16.5322 18.1952 16.8968L17.4515 17.0988C17.296 17.1411 17.2934 17.3607 17.4479 17.4066L18.0857 17.596C19.3198 17.9606 20.169 18.9642 20.3313 20.2498L20.414 20.905C20.4343 21.0658 20.6533 21.098 20.719 20.9498L21.0295 20.2498C21.5994 18.9642 22.7693 17.9606 24.1167 17.596L24.8604 17.394C25.0159 17.3517 25.0184 17.132 24.864 17.0862L24.2261 16.8968Z",
						fill: "url(#paint2_linear_132_10897)"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M14.9877 20.45L14.9547 20.1922C14.9342 20.0316 14.7153 19.9996 14.6497 20.1478L14.5159 20.45C14.0404 21.5251 13.0629 22.3671 11.9344 22.6716L11.6159 22.7571C11.4598 22.799 11.4572 23.0195 11.6122 23.0651L11.859 23.1377C12.8893 23.4421 13.6026 24.2841 13.7384 25.3592L13.7714 25.617C13.7919 25.7776 14.0108 25.8096 14.0764 25.6615L14.2102 25.3592C14.6857 24.2841 15.6632 23.4421 16.7917 23.1377L17.1102 23.0521C17.2663 23.0102 17.2689 22.7897 17.1139 22.7441L16.8671 22.6716C15.8368 22.3671 15.1235 21.5251 14.9877 20.45Z",
						fill: "url(#paint3_linear_132_10897)"
					})
				]
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				filter: "url(#filter1_f_132_10897)",
				style: { mixBlendMode: "soft-light" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M35.5205 23.6798C35.5205 16.9641 26.7811 23.6798 16.0005 23.6798C5.21987 23.6798 -3.51953 16.9641 -3.51953 23.6798C-3.51953 30.3956 5.21987 35.8398 16.0005 35.8398C26.7811 35.8398 35.5205 30.3956 35.5205 23.6798Z",
					fill: "url(#paint4_linear_132_10897)"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				filter: "url(#filter2_f_132_10897)",
				style: { mixBlendMode: "overlay" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M35.5205 30.1859C35.5205 27.8 26.7811 30.1859 16.0005 30.1859C5.21987 30.1859 -3.51953 27.8 -3.51953 30.1859C-3.51953 32.5717 5.21987 34.5059 16.0005 34.5059C26.7811 34.5059 35.5205 32.5717 35.5205 30.1859Z",
					fill: "url(#paint5_linear_132_10897)"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				filter: "url(#filter3_f_132_10897)",
				style: { mixBlendMode: "soft-light" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M35.3327 12.334C35.3327 20.6183 26.6769 8.33398 15.9993 8.33398C5.32184 8.33398 -3.33398 20.6183 -3.33398 12.334C-3.33398 4.04971 5.32184 -2.66602 15.9993 -2.66602C26.6769 -2.66602 35.3327 4.04971 35.3327 12.334Z",
					fill: "url(#paint6_linear_132_10897)"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				filter: "url(#filter4_f_132_10897)",
				style: { mixBlendMode: "soft-light" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M35.5205 4.21313C35.5205 7.39429 26.7811 1.9998 16.0005 1.9998C5.21987 1.9998 -3.51953 7.39429 -3.51953 4.21313C-3.51953 1.03197 5.21987 -1.54688 16.0005 -1.54688C26.7811 -1.54688 35.5205 1.03197 35.5205 4.21313Z",
					fill: "url(#paint7_linear_132_10897)"
				})
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_dddd_132_10897",
			x: 3.19906,
			y: 4.79945,
			width: 26.0447,
			height: 34.8261,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: .64 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .64 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0.07 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_132_10897"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 2.24 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.12 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0.06 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_132_10897",
					result: "effect2_dropShadow_132_10897"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 5.44 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.6 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0.04 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect2_dropShadow_132_10897",
					result: "effect3_dropShadow_132_10897"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 9.6 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.92 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0.01 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect3_dropShadow_132_10897",
					result: "effect4_dropShadow_132_10897"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect4_dropShadow_132_10897",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter1_f_132_10897",
			x: -6.39953,
			y: 17.8153,
			width: 44.8,
			height: 20.9045,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 1.44,
					result: "effect1_foregroundBlur_132_10897"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter2_f_132_10897",
			x: -6.39953,
			y: 26.245,
			width: 44.8,
			height: 11.1409,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 1.44,
					result: "effect1_foregroundBlur_132_10897"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter3_f_132_10897",
			x: -6.21398,
			y: -5.54602,
			width: 44.4265,
			height: 23.6291,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 1.44,
					result: "effect1_foregroundBlur_132_10897"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter4_f_132_10897",
			x: -6.39953,
			y: -4.42688,
			width: 44.8,
			height: 12.5237,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 1.44,
					result: "effect1_foregroundBlur_132_10897"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint0_radial_132_10897",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(16 32) rotate(-90) scale(32)",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#610CFF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E54D2E"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_132_10897",
			x1: 13.4286,
			y1: 5.43945,
			x2: 13.4286,
			y2: 18.1672,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#D8CEFF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_132_10897",
			x1: 21.1559,
			y1: 13.0176,
			x2: 21.1559,
			y2: 21.4752,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#D8CEFF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_132_10897",
			x1: 14.3631,
			y1: 19.623,
			x2: 14.3631,
			y2: 26.1862,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#D8CEFF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint4_linear_132_10897",
			x1: 16.0005,
			y1: 35.8398,
			x2: 16.0005,
			y2: 11.5198,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {}), /* @__PURE__ */ _jsx("stop", {
				offset: .63,
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint5_linear_132_10897",
			x1: 16.0005,
			y1: 34.5059,
			x2: 16.0005,
			y2: 25.8659,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {}), /* @__PURE__ */ _jsx("stop", {
				offset: .63,
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint6_linear_132_10897",
			x1: 15.9993,
			y1: -2.66602,
			x2: 15.9993,
			y2: 27.334,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
				offset: .63,
				stopColor: "white",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint7_linear_132_10897",
			x1: 16.0005,
			y1: -1.54687,
			x2: 16.0005,
			y2: 9.97313,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
				offset: .63,
				stopColor: "white",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_132_10897",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 32,
				rx: 9.33333,
				fill: "white"
			})
		})
	] })]
});
const ForwardRef = forwardRef(SvgFavicon);
export default ForwardRef;
